// organize-imports-ignore
import './core/inter-ui/index.js';
import lazySizes from 'lazysizes';
import React from 'react';
import { isPrerendering } from '@pendwa/common-browser/utils/isPrerendering.js';
if (typeof document === 'undefined') {
    React.useLayoutEffect = React.useEffect;
}
// disable lazy sizes for prerendering so that images are not loaded and class is not replaced
if (isPrerendering()) {
    lazySizes.cfg.init = false;
}
if (!deploymentProduction) {
    console.info(`LAST_COMMIT_SHA = ${LAST_COMMIT_SHA}`);
    console.info(`GIT_TAG_NAME = ${GIT_TAG_NAME}`);
    console.info(`MACHINE_ENV = ${MACHINE_ENV}`);
    console.info(`DOMAIN_ENV = ${DOMAIN_ENV}`);
}
//# sourceMappingURL=entrypoint.js.map